var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState, } from "react";
import { Field } from "formik";
import { styled } from "../../theme";
import { Button } from "../../button";
import { FloatingFieldLabel } from "../atoms/FloatingFieldLabel";
import { FileInput } from "../atoms/file-input";
import { FieldError } from "../atoms/field-error";
import { Label } from "../atoms/Label";
import { ExternalLink } from "../../external-link";
var PRE_SIGNED_URL_REFRESH_INTERVAL = 60000; // 1 minute
export var FileField = function (_a) {
    var name = _a.name, label = _a.label, title = _a.title, emptyMessage = _a.emptyMessage, uploadedMessage = _a.uploadedMessage, acceptedMediaTypes = _a.acceptedMediaTypes, disabled = _a.disabled, FormField = _a.FormField, queryVariables = _a.queryVariables;
    return (React.createElement(FormField, { name: name }, function (_a) {
        var field = _a.field, form = _a.form;
        var value = field.value;
        var setFieldTouched = form.setFieldTouched, setFieldValue = form.setFieldValue;
        var onChange = function (event) {
            setFieldTouched(name, true);
            setFieldValue(name, event.currentTarget.files[0]);
        };
        var onRemove = function () {
            setFieldValue(name, undefined);
        };
        return (React.createElement(React.Fragment, null,
            label && (React.createElement(Label, { htmlFor: name },
                React.createElement(FloatingFieldLabel, { visible: true }, label))),
            React.createElement(Wrapper, null,
                React.createElement(FileInputTrigger, { disabled: disabled },
                    React.createElement("span", null, title),
                    React.createElement(FileInput, { id: name, name: name, acceptedMediaTypes: acceptedMediaTypes, disabled: disabled, onChange: onChange })),
                React.createElement(FileInputValue, { name: name, value: value, onRemove: onRemove, emptyMessage: emptyMessage, uploadedMessage: uploadedMessage, disabled: disabled, queryVariables: queryVariables })),
            React.createElement(FieldError, { name: name })));
    }));
};
FileField.defaultProps = {
    title: "Upload File",
    emptyMessage: "No file chosen",
    uploadedMessage: "Show current content",
    disabled: false,
    FormField: Field,
};
export var FileInputValue = function (_a) {
    var name = _a.name, value = _a.value, emptyMessage = _a.emptyMessage, uploadedMessage = _a.uploadedMessage, disabled = _a.disabled, onRemove = _a.onRemove, queryVariables = _a.queryVariables;
    if (!value) {
        return React.createElement("label", { htmlFor: name }, emptyMessage);
    }
    var _b = useState(null), preSignedUrl = _b[0], setPreSignedUrl = _b[1];
    useEffect(function () {
        var fetchFileDetails = function (url, fileId) { return __awaiter(void 0, void 0, void 0, function () {
            var response, data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_API_GATEWAY_URL, "/v3/files/").concat(fileId), {
                                headers: {
                                    Authorization: queryVariables === null || queryVariables === void 0 ? void 0 : queryVariables.getCommonAuthorizationHeader(),
                                },
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        setPreSignedUrl(data.url);
                        return [2 /*return*/, data];
                    case 3:
                        error_1 = _a.sent();
                        // eslint-disable-next-line no-console
                        console.error("Failed to fetch pre-signed URL:", error_1);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        if (!(value instanceof File)) {
            // Call immediately
            fetchFileDetails(value === null || value === void 0 ? void 0 : value.url, value === null || value === void 0 ? void 0 : value.id);
            // Set up interval to refresh every minute (60,000 ms) for now
            var intervalId_1 = setInterval(function () {
                fetchFileDetails(value === null || value === void 0 ? void 0 : value.url, value === null || value === void 0 ? void 0 : value.id);
            }, PRE_SIGNED_URL_REFRESH_INTERVAL);
            // Cleanup interval on unmount or dependency change
            return function () { return clearInterval(intervalId_1); };
        }
    }, [value, queryVariables]);
    return (React.createElement(React.Fragment, null,
        value instanceof File ? (React.createElement(OverflowEllipsis, null, value.name)) : (React.createElement(ExternalLink, { href: preSignedUrl }, uploadedMessage)),
        React.createElement(ButtonWrapper, null,
            React.createElement(Button, { outline: true, color: "danger", size: "small", icon: "close", disabled: disabled, onClick: onRemove }, "Remove"))));
};
var OverflowEllipsis = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  width: 100%;\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])));
var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n\n  margin-top: 15px;\n  margin-bottom: 5px;\n\n  width: 100%;\n"], ["\n  display: inline-flex;\n  align-items: center;\n\n  margin-top: 15px;\n  margin-bottom: 5px;\n\n  width: 100%;\n"])));
var ButtonWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: 16px;\n"], ["\n  margin-left: 16px;\n"])));
/**
 * Note: <Button /> can't be reused here, as we are very custom.
 */
export var FileInputTrigger = styled.label(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-right: 16px;\n  padding: 12px 32px;\n  border-radius: 5px;\n  border: 1px solid ", ";\n\n  background-color: ", ";\n  color: ", ";\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);\n\n  font-weight: ", ";\n  font-size: 15px;\n  white-space: nowrap;\n  cursor: pointer;\n\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n    transform: translateY(-1px);\n  }\n\n  ", "\n"], ["\n  margin-right: 16px;\n  padding: 12px 32px;\n  border-radius: 5px;\n  border: 1px solid ", ";\n\n  background-color: ", ";\n  color: ", ";\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);\n\n  font-weight: ", ";\n  font-size: 15px;\n  white-space: nowrap;\n  cursor: pointer;\n\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n    transform: translateY(-1px);\n  }\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.color.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.color.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontWeight.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.color.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.color.white;
}, function (_a) {
    var disabled = _a.disabled;
    return disabled &&
        "\n    opacity: 0.6;\n    cursor: not-allowed;\n    filter: saturate(25%);\n  ";
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
